"use strict";

var React = require('react');
var ReactForms = require('react-forms');

var settings = require('ofs/settings');
var i18n = require('ofs/i18n');
var gettext = i18n.gettext;
var interpolate = i18n.interpolate;

var Scalar = require('ofs/forms/scalars/Scalar');
var SelectOne = require('ofs/forms/inputs/simple-choice');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var messages = {
  FIRST_NAME_LABEL: gettext('First name'),
  LAST_NAME_LABEL: gettext('Second name'),
  LOCATION_LABEL: gettext('Location'),
  BOOKING_REF_LABEL: gettext('Booking reference'),
  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>%(city_name)s team</b> directly'),
  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
};

var locationOptions = [
  {value: 'LON', name: 'London'},
  {value: 'LAX', name: 'Los Angeles'},
  {value: 'NYC', name: 'New York'},
  {value: 'PAR', name: 'Paris'},
  {value: 'OTHER', name: 'Other'},
];


var mapping = function(defaultValues) {
  return {
    first_name: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('firstName', null),
      label: messages.FIRST_NAME_LABEL
    }),
    last_name: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('lastName', null),
      label: messages.LAST_NAME_LABEL
    }),
    location: Scalar({
      type: 'string',
      input: <SelectOne options={locationOptions} />,
      defaultValue: defaultValues.get('cityCode') || 'LON', 
      label: messages.LOCATION_LABEL
    }),
    booking_ref: Scalar({
      type: 'string',
      defaultValue: defaultValues.get('bookingRef', null),
      label: messages.BOOKING_REF_LABEL
    })
  };
};

var layout = function(value) {
  return (
    <Group>
      <Row>
        <Column size="half"><FormElement value={value.get('first_name')} /></Column>
        <Column size="half"><FormElement value={value.get('last_name')} /></Column>
      </Row>
      <Row>
        <Column size="half"><FormElement value={value.get('location')} /></Column>
        <Column size="half"><FormElement value={value.get('booking_ref')} /></Column>
      </Row>
    </Group>
  );
};


var Footer = React.createClass({
  render() {
    var footerMsg = interpolate(messages.FOOTER_MESSAGE, {
      city_name: this.props.cityName
    }, true);

    var contact = settings.cities[this.props.cityCode].contact;
    var contactMsg = interpolate(messages.CONTACT_MESSAGE, {
      phone_number: contact['guests']['phone'],
      email_url: `mailto:${ contact['guests']['email'] }`,
      email_address: contact['guests']['email']
    }, true);

    return (
      <div className="ofs-InfoPanel u-text-center">
        <p dangerouslySetInnerHTML={{__html: footerMsg}} />
        <p dangerouslySetInnerHTML={{__html: contactMsg}} />
      </div>
    );
  }
});


module.exports = {mapping, layout, Footer};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/booking.jsx
 **/